import { settings } from "app";
import permissions from "app/permissions";
import BackButtonToolbar from "features/BackButtonToolbar";
import { BooleanField, EditButton, Show, SimpleShowLayout, TextField } from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";

const ShowHospitality = () => {
  return (
    <Show
      title="Детайли на болница"
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canManageHospitalities}>
              <EditButton
                variant="contained"
                size="medium"
              />
            </SecuredComponent>
          }
        />
      }
    >
      <SimpleShowLayout sx={{ ...settings.style.shadowBox, padding: "2rem" }}>
        <TextField
          source="nameBg"
          label="Име на български"
        />
        <TextField
          source="nameEn"
          label="Име на английски"
        />
        <BooleanField
          source="visibleInCandidateCampaigns"
          label="Видима в кандидатстудентски кампании"
        />
      </SimpleShowLayout>
    </Show>
  );
};
export default ShowHospitality;
